export default function DeleteStudents(){
    return <h1>Delete Students</h1>
}